export const MODULE_NAME = 'BOOKING_MODULE';
